<template>
  <div>
    <div class="container-md">
      <div class="row">
        <div class="col-6">
          <h3 class="text-uppercase">{{ committee.title }}</h3>
        </div>
        <div class="col-6">
          <!-- <i class="float-right fa fa-plus" data-toggle="modal" data-target="#newItemgroup" style="font-size: 24px;cursor: pointer" v-on:click="newCommittee"></i> -->
        </div>
      </div>
      <div v-show="committee.id" class="grid">
        <div
          v-bind:style="{
            'grid-row-start': getBlockPosition('Over')[0],
            'grid-column-start': getBlockPosition('Over')[1],
          }"
          class=""
          v-if="getBlockVisible('Over')"
        >
          <div class="p-3 container-bg" style="height: 283px">
            <div class="card">
              <div
                class="p-2 pt-3 row no-gutters align-items-center"
                style="border-radius: 20px"
              >
                <div class="col-md-3 col-12 text-sm-center">
                  <img
                    :src="
                      committee.profile_image
                        ? committee.profile_image
                        : '/assets/img/blank-profile-picture-973460_640.png'
                    "
                    style="
                      width: 80px;
                      height: 80px;
                      border: 1px solid #ffffff;
                      border-radius: 50%;
                    "
                    class="img-fluid"
                    alt=""
                  />
                </div>
                <div class="col-md-9 col-12">
                  <div class="px-2 card-block">
                    <h3
                      style="display: flex; justify-content: space-between"
                      class="text-white text-uppercase"
                    >
                      <span>{{ committee.title }}</span>
                      <a
                        v-if="canEditBlock"
                        style="font-size: 15px; color: white"
                        data-toggle="modal"
                        data-dismiss="modal"
                        href="#editCommittee"
                        ><i class="fas fa-edit"></i
                      ></a>
                    </h3>

                    <p
                      class="text-white"
                      style="line-height: normal; font-size: 12px"
                      v-html="reduceString(committee.description, 150)"
                    ></p>

                    <div id="showDescription" class="modal fade">
                      <div class="modal-dialog">
                        <div class="modal-content modal-md committee-modal">
                          <div class="modal-body">
                            <p class="m-0" v-html="committee.description"></p>
                            <div class="mt-3">
                              <button data-dismiss="modal" class="btn btn-sm">
                                Sluiten
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- EDIT COMMITTEE -->
                    <editCommitteeModal
                      v-show="committee.id != undefined"
                      :committee="committee"
                      :isEdit="isEdit"
                    ></editCommitteeModal>
                    <button
                      v-if="committee.description"
                      data-target="#showDescription"
                      data-toggle="modal"
                      class="mt-2 text-white btn btn-small-mvn btn-sm btn-dark"
                    >
                      Lees meer
                    </button>
                  </div>
                </div>
              </div>
              <div class="card-footer w-100" v-if="committee.users.length > 0">
                <div class="row align-items-center">
                  <div class="col-12">
                    <userModal :users="committee.users"></userModal>
                    <button
                      data-target="#userListModal"
                      data-toggle="modal"
                      class="text-white btn btn-dark"
                    >
                      Leden
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-bind:style="{
            'grid-row-start': getBlockPosition('Taken')[0],
            'grid-column-start': getBlockPosition('Taken')[1],
          }"
          class=""
          v-if="getBlockVisible('Taken')"
        >
          <committee-tasks
            :committee="committee"
            :committees="committees"
          ></committee-tasks>
        </div>
        <!-- EVENT BLOCK -->
        <div
          v-bind:style="{
            'grid-row-start': getBlockPosition('Agenda')[0],
            'grid-column-start': getBlockPosition('Agenda')[1],
          }"
          class=""
          v-if="getBlockVisible('Agenda')"
        >
          <committee-events
            :id="committee.id"
            :can-add-event="canAddEvent"
            :committees="committees"
          ></committee-events>
        </div>

        <div
          v-bind:style="{
            'grid-row-start': getBlockPosition('Nieuws')[0],
            'grid-column-start': getBlockPosition('Nieuws')[1],
          }"
          class=""
        >
          <div
            class="p-3 container-bg custom-scrollbar"
            style="height: 283px; box-shadow: unset"
            v-if="getBlockVisible('Nieuws')"
          >
            <h3 class="text-center">
              NIEUWS
              <i
                v-if="canAddEvent"
                @click="createNewsItemModal()"
                data-toggle="modal"
                data-target="#newsitemModal"
                class="ml-3 fa fa-plus"
                style="font-size: 24px; cursor: pointer"
              ></i>
            </h3>
            <div
              v-for="(item, index) in committee.newsitems"
              :key="'news' + index"
              class="p-2 flex-container flex-body"
            >
              <div class="text-white item" style="flex: 18 1 0%">
                <p style="margin: 0">{{ item.title }}</p>
              </div>
              <div class="item">
                <button
                  v-if="item.public == 1"
                  data-target="#newsDescription"
                  data-toggle="modal"
                  @click="viewNews(item)"
                  class="text-white btn btn-small-mvn btn-sm btn-dark close-bg"
                >
                  Open
                </button>
                <a
                  @click="editNews(item)"
                  class="ml-1 text-white btn btn-small-mvn btn-sm btn-dark"
                  href="javascript:void(0)"
                  v-if="isCommitteeMember"
                  ><i class="fa fa-edit"></i
                ></a>
              </div>
            </div>
          </div>
        </div>
        <div
          v-bind:style="{
            'grid-row-start': getBlockPosition('Informatie')[0],
            'grid-column-start': getBlockPosition('Informatie')[1],
          }"
          class=""
        >
          <div
            class="p-3 container-bg custom-scrollbar"
            style="height: 283px"
            v-if="getBlockVisible('Informatie')"
          >
            <h3 class="text-center text-uppercase">
              Informatie
              <!-- <i
                v-if="canAddEvent"
                class="ml-3 fa fa-plus"
                data-toggle="modal"
                data-target="#itemgroupsModal"
                style="font-size: 24px; cursor: pointer"
              ></i> -->
            </h3>
            <router-link
              :to="'/itemgroups/' + itemgroup.id + '/' + itemgroup.title_slug"
              style="text-decoration: none; color: inherit"
              v-for="(itemgroup, ind) in committee.itemgroups"
              :key="'committe_itemgroup' + ind"
            >
              <div class="p-2 flex-container flex-body">
                <div class="text-white item" style="flex: 0">
                  <i class="text-white fa fa-eye"></i>
                </div>
                <div class="text-white item">
                  <p style="margin: 0">{{ itemgroup.title }}</p>
                </div>
              </div>
            </router-link>
          </div>
        </div>
        <div
          v-bind:style="{
            'grid-row-start': getBlockPosition('Documenten')[0],
            'grid-column-start': getBlockPosition('Documenten')[1],
          }"
          class=""
        >
          <div
            class="p-3 container-bg custom-scrollbar"
            style="height: 283px; box-shadow: unset"
            v-if="getBlockVisible('Documenten')"
          >
            <h3 class="text-center">
              DOCUMENTEN
              <i
                v-if="canAddEvent"
                class="ml-3 fa fa-plus"
                data-toggle="modal"
                data-target="#documentModal"
                style="cursor: pointer"
              ></i>
            </h3>
            <div
              v-for="(folder, name, index) in committee_file_collections"
              :key="index"
              class="p-2 flex-container flex-body"
            >
              <div
                class="d-flex w-100"
                data-toggle="collapse"
                :data-target="'#dropdown-items-' + index"
                @click="rotateChevron('.arrow-dropdown-items-' + index)"
              >
                <div class="item">
                  <i
                    class="text-white fa fa-folder"
                    aria-hidden="true"
                    style="font-size: 24px; cursor: pointer"
                  ></i>
                </div>

                <div class="text-white item" style="flex: 18 1 0%">
                  <p style="margin: 0">{{ name }}</p>
                </div>
                <div class="item">
                  <span
                    class="float-right ml-3 panel-heading collapsed"
                    style="cursor: pointer"
                  >
                    <i
                      :class="'arrow-dropdown-items-' + index"
                      class="chevron fa"
                    ></i
                  ></span>
                </div>
              </div>

              <div
                :id="'dropdown-items-' + index"
                class="collapse w-100"
                style="margin-right: 10px"
              >
                <div
                  v-for="(file, index2) in folder"
                  :key="index2"
                  class="mx-4 bg-white flex-container"
                  style="display: flex; flex-wrap: nowrap"
                >
                  <div class="item" style="flex: 0 auto">
                    <a :href="getFileUrl(file)" target="_blank">
                      <img
                        src="/assets/img/Docicon.svg"
                        alt=""
                        style="padding-left: 10px"
                      />
                    </a>
                  </div>
                  <div class="item text-truncate">
                    <a
                      :href="getFileUrl(file)"
                      target="_blank"
                      style="color: inherit; text-decoration: inherit"
                    >
                      <span>{{ file.media.file_name }}</span>
                    </a>
                  </div>
                  <div class="item" v-if="isCommitteeMember">
                    <a @click="deleteFile(file)" href="javascript:void(0)">
                      <img src="/assets/img/trash-alt.svg" class="ml-1" />
                    </a>
                    <!-- <img src="/assets/img/Edit.svg" alt="" class="ml-1"> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--        Delete Modal-->
    <div
      class="modal fade"
      id="deleteModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog delete-modal" role="document">
        <div class="modal-content">
          <div class="modal-header" style="border-bottom: unset">
            <button
              type="button"
              class="close close-modal-button"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p class="text-center">
              Are you sure you want to delete it? This will affect all members
              related.
            </p>
            <div class="text-center">
              <button class="mt-3 btn-dark">Yes, delete</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--        document modal-->
    <div
      class="modal fade"
      id="documentModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header" style="border-bottom: unset">
            <button
              type="button"
              class="close close-modal-button"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-7 col-12 pl-md-5 pr-md-5">
                <div class="row">
                  <div class="mb-3 col-md-12">
                    <h5 class="text-uppercase">Voeg bestand toe</h5>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label
                        >Maak of selecteer een map voor je bestand(en):</label
                      >
                      <div class="mt-2 ml-3 row">
                        <div class="col-lg-12">
                          <div class="form-check">
                            <input
                              @click="selectFolder('new')"
                              name="foldername"
                              class="form-check-input"
                              type="radio"
                              :id="'newfolder'"
                            />
                            <label class="form-check-label" :for="'newfolder'"
                              >Maak een nieuwe map aan
                            </label>
                          </div>
                        </div>
                        <div v-if="new_foldername" class="pl-5 col-md-12">
                          <div class="form-group">
                            <div class="mt-2 ml-3 row">
                              <label for="name" style="margin-top: 5px"
                                >Mapnaam:</label
                              >
                              <div class="col-lg-6">
                                <input
                                  v-model="foldername"
                                  type="text"
                                  class="form-control"
                                  id=""
                                  style="width: 300px"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          v-for="(folder, index) in committee.file_collections"
                          :key="index"
                          class="col-lg-6"
                        >
                          <div class="form-check">
                            <input
                              @click="selectFolder(index)"
                              name="foldername"
                              class="form-check-input"
                              type="radio"
                              :id="'defaultCheck-' + index.replace(' ', '')"
                            />
                            <label
                              class="form-check-label"
                              :for="'defaultCheck-' + index.replace(' ', '')"
                            >
                              {{ index }}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-10">
                    <div class="form-group">
                      <input
                        type="text"
                        class="form-control"
                        id="name_bestand"
                        v-model="filename"
                        placeholder="Bestandsnaam..."
                      />
                      <input
                        @change="addFiles()"
                        type="file"
                        class="d-none"
                        id="files"
                      />
                    </div>
                  </div>
                  <div class="col-md-2">
                    <button @click="triggerDialog()" class="btn btn-dark">
                      <i class="text-white fa fa-paperclip rotate-left-42"></i>
                    </button>
                  </div>
                  <div class="selected-files col-12">
                    <div class="form-group">
                      <label for="name">Voeg bestanden toe:</label>
                    </div>
                    <div
                      v-for="(file, index) in files"
                      :key="index"
                      class="row selected-file"
                    >
                      <div class="col-lg-1">
                        <img src="/assets/img/attach_blue.svg" alt="" />
                      </div>
                      <div class="col-lg-10">
                        <label style="color: #4192d9">{{ file.name }}</label>
                      </div>
                      <div class="col-lg-1">
                        <a
                          href="javascript:void(0)"
                          @click="removeFile(file.id)"
                        >
                          <i
                            class="fa fa-trash text-danger"
                            style="color: #4192d9"
                            aria-hidden="true"
                          ></i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <!-- <i class="float-left fa fa-plus" style="font-size: 24px;cursor: pointer; margin-left: 14px; margin-top: 8px;"> </i> -->
                </div>
              </div>
            </div>

            <div class="col-12">
              <div v-if="files.length > 0" class="row">
                <div class="col-lg-12">
                  <button
                    @click="uploadFiles()"
                    class="float-left pt-1 pb-1 mt-5 btn-dark"
                  >
                    <span v-if="uploading">uploading....</span>
                    <span v-else
                      >UPLOAD FILES &nbsp; <i class="fas fa-check"></i
                    ></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--        itemgroups modal start-->
    <div
      class="modal fade"
      id="itemgroupsModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header" style="border-bottom: unset">
            <button
              type="button"
              class="close close-modal-button"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-7 col-12 pl-md-5 pr-md-5">
                <div class="row">
                  <div class="mb-3 col-md-12">
                    <h5 class="text-uppercase">Create a new itemgroup</h5>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <img
                        src="/assets/img/blank-profile-picture-973460_640.png"
                        style="
                          height: 100px;
                          width: 100px;
                          margin-left: -8px;
                          margin-top: -8px;
                          border: 1px solid #ffffff;
                          border-radius: 50%;
                        "
                        alt=""
                      />
                      <button class="ml-3 btn-dark">Upload</button>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="name">Name</label>
                      <input type="text" class="form-control" id="" />
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="textarea">Include items :</label>
                      <div class="row">
                        <div class="col-lg-1">
                          <img src="/assets/img/attach_blue.svg" alt="" />
                        </div>
                        <div class="col-lg-7">
                          <label style="color: #4192d9"
                            >Main Song: Dolor setsum lorem</label
                          >
                        </div>
                        <div class="col-lg-3">
                          <i
                            class="fa fa-trash"
                            style="color: #4192d9; margin-left: 110px"
                            aria-hidden="true"
                          ></i>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-1">
                          <img src="/assets/img/attach_blue.svg" alt="" />
                        </div>
                        <div class="col-lg-7">
                          <label style="color: #4192d9"
                            >Second Song: Lorem ipsum</label
                          >
                        </div>
                        <div class="col-lg-3">
                          <i
                            class="fa fa-trash"
                            style="color: #4192d9; margin-left: 110px"
                            aria-hidden="true"
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-10">
                    <div class="form-group">
                      <input
                        type="text"
                        class="form-control"
                        id="name_itemgroup"
                        value="Text input name"
                      />
                    </div>
                  </div>
                  <div class="col-md-2">
                    <button class="btn btn-dark">
                      <img src="/assets/img/attach_blue.svg" alt="" />
                    </button>
                  </div>

                  <i
                    class="float-left fa fa-plus"
                    style="
                      font-size: 24px;
                      cursor: pointer;
                      margin-left: 14px;
                      margin-top: 8px;
                    "
                  ></i>
                  <div class="col-md-12">
                    Select members:
                    <members></members>
                  </div>
                </div>
              </div>
              <div class="col-md-5 col-12 pl-md-2 pr-md-5">
                <div class="row">
                  <div class="p-0 mb-3 col-md-12 col-12">
                    If proceeds select an existing itemgroup to contain the new
                    one:
                  </div>
                  <div class="pt-4 pb-4 col-md-12 col-12 pl-md-5 container-bg">
                    <div class="row">
                      <div
                        class="col-md-10 custom-scrollbar"
                        style="height: 200px"
                      >
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            value=""
                            id="defaultCheck1"
                          />
                          <label class="form-check-label" for="defaultCheck1">
                            Amy member name
                          </label>
                        </div>
                        <div class="pt-3 form-check">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            value=""
                            id="defaultCheck1"
                          />
                          <label class="form-check-label" for="defaultCheck1">
                            Borem ipsum
                          </label>
                        </div>
                        <div class="pt-3 form-check">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            value=""
                            id="defaultCheck1"
                          />
                          <label class="form-check-label" for="defaultCheck1">
                            Colorumset Qutern
                          </label>
                        </div>
                        <div class="pt-3 form-check">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            value=""
                            id="defaultCheck1"
                          />
                          <label class="form-check-label" for="defaultCheck1">
                            Dember name
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="p-0 mb-3 col-md-12 col-12">
                    Select related committees:
                  </div>
                  <div class="pt-4 pb-4 col-md-12 col-12 pl-md-5 container-bg">
                    <div class="row">
                      <div
                        class="col-md-10 custom-scrollbar"
                        style="height: 200px"
                      >
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            value=""
                            id="defaultCheck1"
                          />
                          <label class="form-check-label" for="defaultCheck1">
                            Music
                          </label>
                          <span
                            class="ml-5 panel-heading collapsed"
                            data-toggle="collapse"
                            data-target="#dropdown-list"
                            style="cursor: pointer"
                          >
                            <i class="chevron fa" style="margin-left: 90px"></i
                          ></span>
                          <div id="dropdown-list" class="collapse">
                            <div class="mt-0 flex-container">
                              <div class="item">
                                <div class="ml-2">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    value=""
                                    id="defaultCheck1"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="defaultCheck1"
                                  >
                                    Music
                                  </label>
                                </div>
                                <div class="ml-2">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    value=""
                                    id="defaultCheck1"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="defaultCheck1"
                                  >
                                    Genre
                                  </label>
                                </div>
                                <div class="ml-2">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    value=""
                                    id="defaultCheck1"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="defaultCheck1"
                                  >
                                    Rithm
                                  </label>
                                </div>
                                <div class="ml-2">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    value=""
                                    id="defaultCheck1"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="defaultCheck1"
                                  >
                                    Mood
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="pt-3 form-check">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            value=""
                            id="defaultCheck1"
                          />
                          <label class="form-check-label" for="defaultCheck1">
                            Default checkbox
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12">
                <button class="float-right mt-3 btn-dark">Done</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--       News Item Modal-->
    <div
      class="modal fade"
      id="newsitemModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header" style="border-bottom: unset">
            <button
              type="button"
              class="close close-modal-button"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-7 col-12 pl-md-5 pr-md-5">
                <div class="row">
                  <div class="mb-3 col-md-12">
                    <h5 v-if="this.create_news.id" class="text-uppercase">
                      Bewerk
                    </h5>
                    <h5 v-else class="text-uppercase">Maak</h5>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <div class="mt-3 ml-2 row">
                        <div class="col-lg-6">
                          <input
                            v-model="create_news.active"
                            id="activenews"
                            class="mt-1 ml-1 form-check-input"
                            type="checkbox"
                            value=""
                          />
                          <label for="activenews" class="ml-4">Actief</label>
                        </div>
                        <div class="col-lg-6">
                          <input
                            v-model="create_news.public"
                            id="publicnews"
                            class="mt-1 ml-1 form-check-input"
                            type="checkbox"
                            value=""
                          />
                          <label for="publicnews" class="ml-4">Publiek</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="name_news">Titel</label>
                      <input
                        v-model="create_news.name"
                        type="text"
                        class="form-control"
                        id="name_news"
                      />
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="newsItemDescription">Bericht:</label>
                      <editor
                        id="newsItemDescription"
                        v-model="create_news.description"
                        :init="{
                          height: 200,
                          menubar: false,
                          language: 'nl',
                          plugins: [
                            'advlist autolink lists link image charmap print preview anchor',
                            'searchreplace visualblocks code fullscreen',
                            'insertdatetime media table paste code help wordcount',
                          ],
                          toolbar:
                            'undo redo | formatselect | bold italic backcolor | \
                                                            alignleft aligncenter alignright alignjustify | \
                                                            bullist numlist outdent indent | removeformat | help',
                        }"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-5 col-12 pl-md-2 pr-md-5">
                <div class="row">
                  <div class="p-0 mb-3 col-md-12 col-12">
                    Auteur:
                    <div class="col-md-10 form-group">
                      <Select2
                        @select="selectAuthor($event)"
                        v-model="create_news.user_id"
                        :options="
                          $store.state.members.map((d) => {
                            return {
                              text: d.firstname + ' ' + d.lastname,
                              id: d.id,
                            };
                          })
                        "
                      ></Select2>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12">
                <button @click="createNews()" class="float-right mt-3 btn-dark">
                  <span v-if="!savingNews">Opslaan</span>
                  <span v-else>Saving...</span>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-start">
            <div class="author d-flex align-items-center">
              <div class="author-img">
                <img class="w-100" :src="author.profile_image" alt="" />
              </div>
              <span>{{ author.display_name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- responsibility modal end-->

    <div
      class="modal fade"
      id="newsDescription"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content committee-modal">
          <div class="modal-header" style="border-bottom: unset">
            <button
              type="button"
              class="close close-modal-button"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-header">
            <h4 class="modal-title">{{ newsitem.title }}</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <p v-html="newsitem.content"></p>
              </div>
              <div class="col-lg-12">
                <button data-dismiss="modal" class="float-right mt-3 btn-dark">
                  Sluiten
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="noFileAccess"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content committee-modal">
          <div class="modal-header" style="border-bottom: unset">
            <button
              type="button"
              class="close close-modal-button"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-header">
            <h4 class="modal-title">
              Je hebt geen toegang tot dit document...
            </h4>
          </div>
        </div>
      </div>
    </div>

    <!-- event modal end-->
    <committeeModal
      v-bind:isEdit="isEdit"
      v-bind:committee="committees"
    ></committeeModal>
  </div>
</template>

<script>
import committeeModal from "./committeeModal";
import editCommitteeModal from "./editCommitteeModal";
import { mapState } from "vuex";
import Members from "../../committees/pages/members";
import axios from "axios";
import CommitteeEvents from "./committeeEvents.vue";
import CommitteeTasks from "./committeeTasks.vue";

export default {
  name: "committee",
  components: {
    Members,
    committeeModal,
    editCommitteeModal,
    CommitteeEvents,
    CommitteeTasks,
  },
  computed: {
    committee_file_collections() {
      let obj = { ...this.committee.file_collections };
      Object.keys(obj).map((key) => {
        let filtered_folfer = obj[key].filter((file) =>
          this.hasFileAccess(file)
        );
        obj[key] = filtered_folfer;
      });

      return obj;
    },
    ...mapState({
      selectedMembers: (state) => state.selectedMembers,
    }),
  },
  data() {
    return {
      isCommitteeMember: false,
      absentieusers: [],
      isEdit: false,
      pdf_loading: false,
      savingNews: false,
      savingTask: false,
      error: "",
      committee: {},
      newsitem: {},
      committees: [],
      event_selected_committees: [],
      new_foldername: false,
      foldername: null,
      filename: null,
      files: [],
      uploading: false,
      create_news: { description: "", active: false, public: false },
      create_event: { active: false, public: false, address: "" },
      showEditDescription: false,
      showEditTaskDescription: false,
      next_event: null,
      eventtypes: [],
      activeUsers: [],
      absentie_loading: true,
      absentie: {
        event_id: 0,
        remarks: "",
        cancelled: 0,
        users: [],
      },
      errormsg: "",
      eventtype_config: null,
      calendar_events: [],
      isAbsentieEdit: true,
      blocks_arrangement: [],
      blocks: [],
      task_members: [],
      canAddEvent: false,
      canEditBlock: false,
      author: {},
    };
  },
  methods: {
    selectAuthor(val) {
      console.log(val);
      this.author = this.$store.state.members.find((item) => val.id == item.id);
      console.log(this.author);
    },
    getFileUrl(file) {
      if (file.media.custom_properties.public || this.isCommitteeMember) {
        return file.fullUrl;
      } else {
        return "#noFileAccess";
      }
    },
    hasFileAccess(file) {
      if (file.media.custom_properties.public || this.isCommitteeMember) {
        return true;
      } else {
        return false;
      }
    },
    rotateChevron(cls) {
      window.$(cls).toggleClass("rotate-chevron");
    },
    toggleAbsentieUser(obj) {
      var users = this.absentie.users.filter(function(committee) {
        return committee.id != obj.id;
      });
      if (users.length !== this.absentie.users.length) {
        this.absentie.users = users;
      } else {
        this.absentie.users.push({ id: obj.id, title: obj.title });
      }
    },
    editNews(news) {
      this.create_news = {
        id: news.id,
        name: news.title,
        description: news.content,
        public: news.public,
        active: news.active,
        user_id: news.user_id,
      };
      window.$("#newsitemModal").modal("show");
    },
    createNewsItemModal() {
      this.create_news = {
        name: "",
        description: "",
        active: true,
        public: true,
        user_id: this.$store.state.auth.user.id,
      };
    },

    getBlockPosition(label) {
      var row = 0;
      var column = 0;
      if (this.blocks.length == 0) {
        return [row, column];
      }

      if (this.blocks[0].find((d) => d.label == label)) {
        column = 1;
        row = this.blocks[0].findIndex((d) => d.label == label) + 1;
      } else if (this.blocks[1].find((d) => d.label == label)) {
        column = 2;
        row = this.blocks[1].findIndex((d) => d.label == label) + 1;
      }
      return [row, column];
    },

    getBlockVisible(label) {
      if (this.blocks) {
        if (this.blocks[0] && this.blocks[1]) {
          if (this.blocks[0].find((d) => d.label == label)) {
            return this.blocks[0].find((d) => d.label == label).visible;
          } else if (this.blocks[1].find((d) => d.label == label)) {
            return this.blocks[1].find((d) => d.label == label).visible;
          }
        }
      }

      return false;
    },
    removeAbsentieFile(index) {
      var files = [...this.absentie.files];
      files.splice(index, 1);
      this.absentie.files = [...files];
    },
    selectEditEventFile() {
      var file = document.getElementById("attachEventFile").files[0];
      var temp = { ...this.absentie };

      var fileReader = new FileReader();
      var context = this;

      fileReader.onload = function(data) {
        temp.files.push({
          id: Math.round(Math.random() * 99999),
          filename: file.name,
          file: data.target.result,
        });
        context.absentie = { ...temp };
      };
      fileReader.readAsDataURL(file);
    },
    updateEvent(event) {
      this.$store
        .dispatch("put", {
          details: event,
          endpoint: "api/v1/events/" + event.id,
        })
        .then((data) => {
          console.log(data);
          window.location.reload();
        })
        .catch((error) => {
          console.log(error);
        });
    },

    reduceString(data, limit) {
      if (!data) return data;
      return data.length > limit ? data.substr(0, limit) + "..." : data;
    },

    createNews() {
      if (this.savingNews) return false;

      if (this.create_news.id) {
        this.updateNews();
        return false;
      }
      var news = this.create_news;
      this.savingNews = true;
      var formData = new FormData();
      formData.append("title", news.name);
      formData.append("body", news.description);
      formData.append("active", news.active);
      formData.append("public", news.public);
      formData.append("committee_id", this.committee.id);
      formData.append("user_id", news.user_id);

      this.$store
        .dispatch("post", {
          endpoint: "api/v1/newsitems",
          details: formData,
        })
        .then((data) => {
          this.committee.newsitems.push(data.data.data);
          this.savingNews = false;
          this.$store.dispatch("auth/makeNotification", {
            status: "",
            statusText: "Opgeslagen",
          });
          window.$("#newsitemModal").modal("hide");
          //window.location.reload();
          console.log(data);
        })
        .catch((error) => {
          this.savingNews = false;
          console.log(error.request);
        });
    },
    updateNews() {
      if (this.savingNews) return false;

      var news = this.create_news;
      this.savingNews = true;
      var payload = {};
      payload.title = news.name;
      payload.body = news.description;
      payload.active = news.active;
      payload.public = news.public;
      payload.committee_id = this.committee.id;
      payload.user_id = news.user_id;

      this.$store
        .dispatch("put", {
          endpoint: "api/v1/newsitems/" + this.create_news.id,
          details: payload,
        })
        .then((data) => {
          this.savingNews = false;
          window.location.reload();
          console.log(data);
        })
        .catch((error) => {
          this.savingNews = false;
          console.log(error.request);
        });
    },
    canEdit(task) {
      var user = this.$store.state.auth.user;
      return user.tasks.find((id) => id == task.id)
        ? true
        : this.isCommitteeMember;
    },
    viewNews(item) {
      this.newsitem = item;
    },
    toggleEditDescription() {
      this.showEditDescription = false;
      this.showEditDescription = !this.showEditDescription;
    },
    toggleEditTaskDescription() {
      this.showEditTaskDescription = !this.showEditTaskDescription;
    },
    selectFolder(name) {
      if (name == "new") {
        this.foldername = "";
        this.new_foldername = true;
        return false;
      }
      this.new_foldername = false;
      this.foldername = name;
    },
    deleteFile(file) {
      this.$store
        .dispatch(
          "get",
          "api/v1/committee/files/delete/" + this.committee.id + "/" + file.id
        )
        .then((data) => {
          this.committee = data.data.data;

          this.$store.dispatch("auth/makeNotification", {
            status: "",
            statusText: "Verwijderd",
          });
        })
        .catch((error) => {
          console.log(error.request);
        });
    },
    triggerDialog() {
      if (this.foldername == null && !this.new_foldername) {
        alert("You need to select a folder");
        return false;
      }

      if (this.files.length >= 5) {
        alert("You have reached the maximum (5) you can upload at once");
        return false;
      }
      document.getElementById("files").click();
    },
    removeFile(id) {
      this.files = this.files.filter((d) => d.id != id);
    },
    addFiles() {
      var files = document.getElementById("files").files;
      var f = null;
      for (var key in files) {
        if (files[key].size && this.files.length < 5) {
          f = {
            id: Math.round(Math.random() * 99999),
            name: this.filename ?? files[key].name,
            file: files[key],
          };
          this.files.push(f);
          this.readFile(f);
        }
      }
      this.filename = null;
    },
    readFile(file) {
      var fileReader = new FileReader();
      var context = this;
      fileReader.onload = function(data) {
        console.log(data);
        context.files = context.files.map((d) => {
          if (d.id == file.id) {
            d.file = data.target.result;
          }
          return d;
        });
      };
      fileReader.readAsDataURL(file.file);
    },
    uploadFiles() {
      if (this.uploading) {
        return false;
      }
      this.uploading = true;
      var payload = {
        foldername: this.foldername,
        files: this.files,
      };
      console.log(payload);
      this.$store
        .dispatch("post", {
          endpoint: "api/v1/committee/files/uploads/" + this.$route.params.id,
          details: payload,
        })
        .then((data) => {
          console.log(data);
          this.uploading = false;
          this.files = [];
          this.committee = data.data.data;
          window.$("#documentModal").modal("hide");
        })
        .catch((error) => {
          console.log(error);
          this.uploading = false;
        });
    },
    pdf() {
      this.pdf_loading = true;
      axios
        .get(
          process.env.VUE_APP_API_BASE_URL +
            "/api/v1/committees/" +
            this.$route.params.id +
            "/users/pdf",
          {
            responseType: "blob",
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((data) => {
          this.pdf_loading = false;

          const type = data.headers["content-type"];
          const blob = new File([data.data], { type: type });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "pdf.pdf";
          link.click();
        })
        .catch((error) => {
          console.log(error);
          this.pdf_loading = false;
        });
    },
    newCommittee() {
      this.isEdit = false;
    },
    editCommittee() {
      this.isEdit = true;
    },
    updateCommittee() {
      this.$store
        .dispatch("put", {
          endpoint: "api/v1/committees/" + this.$route.params.id,
          details: this.committee,
        })
        .then((data) => {
          console.log(data);
          this.toggleEditDescription();
        })
        .catch((error) => {
          if (error.request.status == 422) {
            var response = JSON.parse(error.request.response).errors;
            for (var err in response) {
              this.error = response[err][0];
            }
          }
        });
    },
    loadTask(id) {
      this.$store
        .dispatch("get", "api/v1/committee/task/" + id)
        .then((data) => {
          console.log("USER", data);
          this.tasks = data.data;
        })
        .catch((error) => {
          if (error.request.status == 422) {
            var response = JSON.parse(error.request.response).errors;
            for (var err in response) {
              this.error = response[err][0];
            }
          }
        });
    },
    loadActiveTask(id) {
      this.$store
        .dispatch("get", "api/v1/committee/task-active/" + id)
        .then((data) => {
          this.tasks = data.data;
        })
        .catch((error) => {
          if (error.request.status == 422) {
            var response = JSON.parse(error.request.response).errors;
            for (var err in response) {
              this.error = response[err][0];
            }
          }
        });
    },
    getEventType() {
      this.$store
        .dispatch("get", "api/v1/eventtypes/committee/" + this.committee.id)
        .then((data) => {
          console.log(data);
        })
        .catch((error) => {
          if (error.request.status == 422) {
            var response = JSON.parse(error.request.response).errors;
            for (var err in response) {
              this.error = response[err][0];
            }
          }
        });
    },
    loadActiveUsers() {
      this.absentie_loading = true;
      this.$store
        .dispatch(
          "get",
          "api/v1/committee/" + this.committee.id + "/users/active/"
        )
        .then((data) => {
          console.log("activeusers", data.data);
          this.activeUsers = data.data.users;
          this.absentie_loading = false;
        })
        .catch((error) => {
          if (error.request.status == 422) {
            var response = JSON.parse(error.request.response).errors;
            for (var err in response) {
              this.error = response[err][0];
            }
          }
        });
    },
  },
  async created() {
    console.log(this.userHasPermissions(["Beheer Activiteiten"]));
    await this.$store
      .dispatch("get", "api/v1/committees/" + this.$route.params.id)
      .then((data) => {
        this.committee = null;
        this.committee = { ...data.data.data };
        this.isEdit = true;
        this.isCommitteeMember = this.committee.users.some(
          (user) => user.id == this.$store.state.auth.user.id
        );
        this.canAddEvent =
          this.userHasPermissions(["Beheer Activiteiten"]) ||
          this.committee.users.some(
            (user) => user.id == this.$store.state.auth.user.id
          );

        this.canEditBlock =
          this.userHasPermissions(["Beheer Groepen", "Beheer Committees"]) ||
          this.committee.administrators.some(
            (admin) => admin.id == this.$store.state.auth.user.id
          );

        this.$store.commit("addBreadcrumb", {
          title: this.committee.title,
          href: "",
        });

        /* if (this.committee.events_with_eventtypes.length > 0) {
          this.next_event = this.committee.events_with_eventtypes[0];
          this.$store
            .dispatch(
              "get",
              "api/v1/event/update-attandees/" + this.next_event.id
            )
            .then((data) => {
              this.absentie = data.data.data;
              this.absentie.users = data.data.data.attendees;
              this.absentieusers = data.data.data.attendees;
              this.next_event.attendees = data.data.data.attendees;
            })
            .catch((error) => {
              console.log("ABSENTIE ERROR!", error);
            });
        } */
        var user = this.$store.state.auth.user;

        if (user.committees.find((id) => id == this.committee.id)) {
          this.loadTask(this.committee.id);
        } else {
          this.loadActiveTask(this.committee.id);
        }
        this.absentie_loading = false;

        this.calendar_events = [
          ...this.committee.reoccuring_events,
          ...this.committee.events_with_eventtypes,
          ...this.committee.on_going_events,
        ].map((event) => {
          const start_date = new Date(event.date_start);
          const start_time =
            start_date.getHours() + ":" + start_date.getMinutes();

          const end_date = new Date(event.date_end);
          const end_time = end_date.getHours() + ":" + end_date.getMinutes();

          return {
            key: event.id,
            highlight: {
              start: { fillMode: "solid" },
              base: { fillMode: "light" },
              end: { fillMode: "solid" },
            },
            popover: {
              label:
                event.title +
                " (Start:" +
                start_time +
                ", End: " +
                end_time +
                ")",
            },
            dates: {
              start: Date.parse(event.date_start),
              end: Date.parse(event.date_end),
            },
          };
        });

        if (this.committee.settings != null) {
          var settings = JSON.parse(this.committee.settings);
          this.blocks = settings.blocks;
        } else {
          this.settings = this.$store.state.committee_settings;
          this.blocks = this.settings.blocks;
        }
      })
      .catch((error) => {
        if (error.request.status == 422) {
          var response = JSON.parse(error.request.response).errors;
          for (var err in response) {
            this.error = response[err][0];
          }
        }
      });

    this.$store
      .dispatch("get", "api/v1/committees-all")
      .then((data) => {
        // console.log(data);
        this.committees = data.data.data;
        this.task_selected_committees = this.committees.map((d) => {
          d.selected = d.id == this.committee.id;
          return d;
        });
        this.event_selected_committees = [...this.task_selected_committees];

        let copy_committees = [...this.committees];

        let itemLink =
          this.committee.parent_id == 2
            ? "groups"
            : this.committee.parent_id == 3
            ? "committees"
            : "";

        var menu = copy_committees
          .filter((c) => c.parent_id == this.committee.parent_id)
          .map((comt) => {
            return {
              title: comt.title,
              href: "/" + itemLink + "/" + comt.id + "/view",
              children: [],
            };
          });

        menu = menu.sort((a, b) => (a.title > b.title && 1) || -1);
        this.$store.state.inner_sidebar = menu;
        this.$store.state.inner_sidebar_backup[itemLink] = menu;
      })
      .catch((error) => {
        if (error.request.status == 422) {
          var response = JSON.parse(error.request.response).errors;
          for (var err in response) {
            this.error = response[err][0];
          }
        }
      });
  },
  mounted() {
    /* if (
      window.tinymce.activeEditor !== null &&
      "parser" in window.tinymce.activeEditor &&
      "parse" in window.tinymce.activeEditor.parser
    ) {
      // When you first load, you rely on the content second times in V-model to use the setContent method to assign.
      window.tinymce.activeEditor.setContent(this.content, { format: "raw" });
    } */
  },
};
</script>

<style>
.author-img {
  width: 50px;
}
.rotate-chevron {
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  transform: "rotate(90deg)";
}
.close-modal-button {
  background-color: unset !important;
}
.grid {
  display: grid;
  grid-gap: 35px 25px;
  grid-template-columns: 50% 50%;
}
.event-btn-edit {
  position: absolute;
  right: 10px;
  top: 5px;
  color: white;
}
.committee-modal {
  background: #4192d9;
  color: white;
}
.committee-modal button {
  background: black;
  color: white;
}
.custom-scrollbar {
  overflow-y: scroll;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: #f4f5f7 0% 0% no-repeat padding-box;
  border-radius: 5px;
}

.custom-scrollbar::-webkit-scrollbar {
  width: 3px;
  background-color: #f5f5f5;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background: #4192d9 0% 0% no-repeat padding-box;
  border-radius: 5px;
}
</style>
<style scoped>
.btn-small-mvn {
  font-size: 11px !important;
  padding: 3px 7px;
  border-radius: 3px !important;
  font-weight: lighter !important;
}
.open-btn {
  background: grey;
  border: none;
}
.hide-texteditor {
  height: 0px !important;
  overflow: hidden;
}
.task.done {
  background: black !important;
}
.selected-file {
  border-bottom: 1px solid lightgray;
  margin-bottom: 10px;
}
.card {
  background: #4192d9 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #0000004b;
  border-radius: 20px;
  padding: 0;
  border: unset;
}

.no-gutters {
  background: #4192d9 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #0000004b;
  border-radius: 20px;
}

.card-footer {
  border-top: unset;
}

.flex-container {
  display: flex;
  flex-flow: row wrap;
  position: relative;
  width: auto;
  align-items: center;
  margin-top: 10px;
  opacity: 1;
}

.flex-body {
  background: #4192d9 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #0000004b;
  border-radius: 20px;
}

.item {
  flex: 0 auto;
  height: auto;
  margin: 4px;
  margin-right: 10px;
  padding: 10px 0;
  width: auto;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 900px;
    margin: 1.75rem auto;
    margin-top: 9rem;
  }

  .delete-modal {
    max-width: 600px !important;
    margin: 1.75rem auto;
  }
}

.form-control,
.input-group-text {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #00000029;
  border-radius: 4px;
  opacity: 1;
  border: 1px #ced4da;
}

.tab-styling {
  padding: 5px !important;
  font-size: 16px !important;
}

.active {
  background-color: #4192d9 !important;
  border: #4192d9;
}

.vc-container {
  width: 100%;
}

.panel-heading .chevron:after {
  content: "\f0d7";
}

.panel-heading.collapsed .chevron:after {
  content: "\f0da";
}

.arrow_box {
  position: relative;
  background: white;
  border: 1px solid #4192d9;
  border-radius: 4px;
}

.arrow_box:after,
.arrow_box:before {
  bottom: 100%;
  left: 25%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.arrow_box:after {
  border-color: rgba(136, 183, 213, 0);
  border-bottom-color: white;
  border-width: 14px;
  margin-left: -57px;
}

.arrow_box:before {
  border-color: rgba(194, 225, 245, 0);
  border-bottom-color: #4192d9;
  border-width: 15px;
  margin-left: -58px;
}

.opmerkingenCol textarea {
  display: none;
}

.rotate-left-42 {
  transform: rotate(-42deg);
}
</style>
